import { initialScoSystemState, IScoSystemState } from '../state/scosystem.state';
import { ScoSystemActions, EScoSystemActions } from '../actions/scosystem.actions';

export const scoSystemReducers = (
    state = initialScoSystemState,
    action: ScoSystemActions
): IScoSystemState => {
    switch (action.type) {
        case EScoSystemActions.AddScoSystem: {
            return {
                ...state,
                scosystem: action.payload
            };
        }
        case EScoSystemActions.DelScoSystem: {
            return {
                ...state,
                scosystem: null
            };
        }

        default:
            return state;
    }
};
